import { mount } from "svelte";
import App from "./App.svelte";
import { initI18n } from "./lib/i18n/i18n.svelte.js";
import { installPreloadErrorHandler } from "@bitcashier/shared/router/staleChunk.js";
import { initSentry } from "./lib/observability/sentry.js";
import { brand } from "./brands/index.js";
import "./app.css";

// Error reporting, started as early as React's index.jsx did (before the app renders) so nothing
// thrown during boot is missed. The SDK itself is fetched in the background, and the whole call is
// a no-op when no DSN is configured for this build.
initSentry();

// Set the language from the `language` cookie before first render (mirrors React's i18next).
initI18n();

// React set these from the brand config via react-helmet + a static favicon per brand build.
// The per-route "{brand} | {page}" suffix is applied by the router as screens mount.
document.title = brand.title;
document.querySelector("link[rel='icon']").href = brand.favicon;

// Recover from a hashed chunk that no longer exists after a redeploy.
installPreloadErrorHandler();

// mount() appends rather than replaces, so the pre-JS spinner in index.html has to go explicitly
// or it stays painted over the app.
const target = document.getElementById("app");
target.replaceChildren();

const app = mount(App, { target });

export default app;
